__turbopack_context__.v({
  "brandPill": "styles-module-scss-module__y2-imW__brandPill",
  "carousel": "styles-module-scss-module__y2-imW__carousel",
  "carouselWrapper": "styles-module-scss-module__y2-imW__carouselWrapper",
  "dropDescription": "styles-module-scss-module__y2-imW__dropDescription",
  "dropLink": "styles-module-scss-module__y2-imW__dropLink",
  "header": "styles-module-scss-module__y2-imW__header",
  "image": "styles-module-scss-module__y2-imW__image",
  "imageWrapper": "styles-module-scss-module__y2-imW__imageWrapper",
  "itemCard": "styles-module-scss-module__y2-imW__itemCard",
  "itemsGrid": "styles-module-scss-module__y2-imW__itemsGrid",
  "navButtonLeft": "styles-module-scss-module__y2-imW__navButtonLeft",
  "navButtonRight": "styles-module-scss-module__y2-imW__navButtonRight",
  "overlayInfo": "styles-module-scss-module__y2-imW__overlayInfo",
  "pricePill": "styles-module-scss-module__y2-imW__pricePill",
  "seeMoreLink": "styles-module-scss-module__y2-imW__seeMoreLink",
  "vendorButton": "styles-module-scss-module__y2-imW__vendorButton",
  "vendorSection": "styles-module-scss-module__y2-imW__vendorSection",
});
